import { Table } from "@/features/Table";
import { useTranslation } from "react-i18next";
import { getM2StaticDataColumns, type M2StaticDatum } from "./columns";
import {
  type FilterM2StaticDatumsSchema,
  FilterM2StaticDatums,
} from "./filter";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";

const client = Clients.M2;
const table_name = Tables.M2_STATIC_DATA;

export const M2StaticDatumsTable = () => {
  const { t } = useTranslation();
  const columns = getM2StaticDataColumns(t);

  return (
    <Table<M2StaticDatum, FilterM2StaticDatumsSchema>
      label={t("m2_static_data.title", {
        ns: "tables",
        defaultValue: "Actifs",
      })}
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterM2StaticDatums />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
